import { IoWarningOutline } from "react-icons/io5";
import { generateAccountInvoicesAsync } from "../../../../../services/invoiceService";
import Toaster from "./../../../../../components/common/Toaster";

const InvoiceConfirmation = ({ id, setLoading, onClose, onSuccess }) => {
  const handleGenerate = async () => {
    try {
      setLoading(true);
      await generateAccountInvoicesAsync(id);
      Toaster.Success("Invoices Generated Successfully");
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <div className="flex justify-center">
        <div>
          <div className="flex justify-center">
            <IoWarningOutline className="text-yellow-500 text-4xl" />
          </div>
          <p className="text-gray-400 text-sm mt-5">
            Are you sure you want to generate invoices?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 mt-12 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button float-right hover:text-blue-400"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            className="button button-primary"
            onClick={() => handleGenerate()}
          >
            Yes, confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceConfirmation;
